import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { height: 8, width: 8, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { r: 3, cx: 4.5, cy: 4.5, fill: "currentColor" }));
export default SvgCircle;
